import React from "react";
import "./DeviceSyncDetailCard.css";
import { convertInRequiredTimeZone } from "utility";
import { titles, formatSyncFrom } from "constants/titles";
import { SYNC_STATUS } from "constants/syncStatus";
import { useSelector } from "react-redux";

const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case SYNC_STATUS.COMPLETED.toLowerCase():
      return "device-sync-status-success";
    case SYNC_STATUS.FAILED.toLowerCase():
      return "device-sync-status-failed";
    case SYNC_STATUS.IN_PROGRESS.toLowerCase():
      return "device-sync-status-pending";
    case SYNC_STATUS.COMPLETED_PARTIALLY_CACHED.toLowerCase():
      return "device-sync-status-cache-completed";
    default:
      return "device-sync-status-default";
  }
};


const RenderMetaItem = ({ title, value, onClick = null }) => (
  <div className="device-sync-meta-item">
    <div className="device-sync-meta-title" onClick={onClick}>
      {title}:
    </div>
    <div className="device-sync-meta-value">{value}</div>
  </div>
);

const DeviceSyncDetailCard = ({ className = "", syncData, onCardClick }) => {
  const { selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
    const { currentTimeZone } = useSelector((store) => store?.common);

  const convertInLocalTimeZone = (date) => {
    return convertInRequiredTimeZone(
      date,
      selectedMedicalUser?.timezone,
      currentTimeZone
    );
  };

  return (
    <div className={`device-sync-card ${className}`}>
      <div className="device-sync-header">
        <div className="device-sync-id">
          <span className="device-sync-id-title">{titles.sync_id}:</span>{" "}
          <p className="device-sync-id-value"> #{syncData?.syncId}</p>
        </div>
        <div
          className={`device-sync-status ${getStatusColor(
            syncData?.syncStatus
          )}`}
        >
          {syncData?.syncStatus}
        </div>
      </div>
      <div className="device-sync-body">
        <div className="device-sync-meta-row">
          <RenderMetaItem
            title={titles.requested_on}
            value={convertInLocalTimeZone(syncData?.syncRequestedOn) || "-"}
          />
          <RenderMetaItem
            title={titles.completed_on}
            value={convertInLocalTimeZone(syncData?.syncCompletedOn) || "-"}
          />
        </div>
        <div className="device-sync-meta-row">
          <RenderMetaItem
            title={titles.sync_type}
            value={syncData?.syncType || "N/A"}
          />
          <RenderMetaItem
            title={titles.sync_event}
            value={syncData?.autoTriggerEvent || "N/A"}
          />
        </div>
        <div className="device-sync-meta-row">
          <RenderMetaItem
            title={titles.total_data_requets}
            value={syncData?.triggerSyncRetries || "N/A"}
          />
          <RenderMetaItem
            title={titles.total_retry}
            value={syncData?.syncRetries}
          />
        </div>
        <div className="device-sync-meta-row">
          <RenderMetaItem
            title={titles.sync_from}
            value={formatSyncFrom(syncData?.syncFrom)}
          />
        </div>
        <div className="device-sync-meta-row">
          <RenderMetaItem
            title={titles.error_code}
            value={syncData?.syncErrorCode || "N/A"}
          />
        </div>
        <div className="device-sync-meta-row">
          <RenderMetaItem
            title={titles.error_message}
            value={syncData?.syncErrorMessage || "No error"}
          />
        </div>
        <div className="device-sync-view-log-container">
          <div
            className="device-sync-view-log"
            onClick={() => onCardClick?.(syncData)}
          >
            {titles.view_logs}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceSyncDetailCard;
